import React, { useState } from "react";
import List from "../workingPartList";
import FrontendTable from "../workingPartFrontendTable";
import Filter from "../workingPartFilter";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import Breadcrumb from "../../../utils/breadCrumbs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ButtonShowError } from "./workingPartFilterList.styled";
import * as WorkingPartServices from "../../../../services/WorkingPartServices";
import * as GeneralServices from "../../../../services/GeneralServices";
import * as XLSX from "xlsx";
import moment from "moment-timezone";
import useFilterState from "../../../../utils/hooks/useFilterState";

const queryClient = new QueryClient();

const WorkingPartFilterListContainer = (props) => {
  const { t } = useTranslation();
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.workingPartSnap.title") },
  ];
  const [filters, setFilters] = useFilterState("workingPartSnap");
  const [showError, setShowError] = useState(false);
  const [allData, setAllData] = useState([]);
  const [loadingAllData, setLoadingAllData] = useState(false);
  const navigate = useNavigate();

  // Función para cargar todos los datos sin paginación
  const loadAllData = async () => {
    setLoadingAllData(true);
    try {
      const filter = {
        page: 1,
        pageSize: 9999, // Número grande para obtener todos
      };
      if (filters) {
        filter.filters = filters;
      }
      const result = await WorkingPartServices.getAllSnapshots(filter);
      setAllData(result || []);
    } catch (error) {
      console.error("Error al cargar todos los datos:", error);
      setAllData([]);
    } finally {
      setLoadingAllData(false);
    }
  };

  // Cargar datos cuando cambian los filtros
  React.useEffect(() => {
    loadAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    setFilters({ showError });
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    setFilters(newFilter);
  };

  const goToRegister = () => {
    // navigate(PATHS.GENERATE_ACCOUNT_LINKS);
  };

  const handlerFilterEmployee = async (value) => {
    let filter = {
      filters: {
        companyCode: value,
      },
    };
    let result = await GeneralServices.listFilterVisualEmployees(filter);
    return result;
  };

  const exportToExcel = async () => {
    const filter = {
      filters,
    };
    WorkingPartServices.listToExport(filter).then((result) => {
      const data = (result || []).map((item) => {
        const periodo = `${item.month}/${item.year}`;
        const employeeCode = item.employeeCode?.[0] || "";
        const employeeName = item.employeeName || "";
        const contractType = item.employeeData?.indefinedContract
          ? "Indefinido"
          : "Temporal";
        const totalHours = Math.trunc(item.totalHours) || 0;
        const status = `${item.conceptData?.status === "PENDING" ? "Si" : "No"}/${item.conceptData?.sendedA3 ? "Si" : "No"}`;
        const normalHours = (item.conceptData?.items || [])
          .reduce((acc, item) => {
            return acc + (item.hoursByType?.[1] || 0);
          }, 0)
          .toFixed(2);
        const nocturnHours = (item.conceptData?.items || [])
          .reduce((acc, item) => {
            return acc + (item.hoursByType?.[5] || 0);
          }, 0)
          .toFixed(2);
        const fitosHours = (item.conceptData?.items || [])
          .reduce((acc, item) => {
            return acc + (item.hoursByType?.[4] || 0);
          }, 0)
          .toFixed(2);
        const compensationHours = item.hoursByType?.[7] || 0;
        const kms = item.totalKms || 0;
        const peonadasTotal = `${Math.trunc(item.peonadas) || 0}/${item.totalParts || 0}`;

        return {
          A: periodo,
          B: employeeCode,
          C: employeeName,
          D: contractType,
          E: totalHours,
          F: status || "",
          G: normalHours,
          H: nocturnHours,
          I: fitosHours,
          J: compensationHours,
          K: kms,
          L: peonadasTotal,
        };
      });
      data.unshift({
        A: "Periodo",
        B: "Cod. Empl.",
        C: "Nombre empleado",
        D: "Tipo de contrato",
        E: "Nº total horas",
        F: "Enviados: Jornadas / Conceptos",
        G: "Horas normales",
        H: "Horas nocturnas",
        I: "Fitos",
        J: "Compensación",
        K: "KMS",
        L: "JJRR/Partes",
      });

      const filename = `Partes_${moment(new Date()).format("DDMMYYYYHHmm")}`;
      const sheetName = "Listado de Partes";
      var ws = XLSX.utils.json_to_sheet(data, {
        header: [
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
        ],
        skipHeader: true,
        UTC: true,
        dateNF: "dd-mm-yyyy hh:mm;@",
      });

      // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
      const wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Listado de Partes",
        Subject: "Exportación de Partes",
        Author: "Agromove",
        CreatedDate: new Date(),
      };
      wb.SheetNames.push(sheetName);
      wb.Sheets[sheetName] = ws;
      XLSX.writeFile(wb, filename + ".xlsx", {
        bookType: "xlsx",
        type: "binary",
      });
    });
  };

  return (
    <>
      <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.workingPartSnap.title")}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
            onFilterEmployee={handlerFilterEmployee}
            initialValues={filters}
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List
              className="marg-top-1rem"
              filters={filters}
              onExport={exportToExcel}
            />
          </QueryClientProvider>
        </div>
      </div>
    </>
  );
};

WorkingPartFilterListContainer.propTypes = {};

export default WorkingPartFilterListContainer;
